import BusinessBadge from "./BusinessBadge";


export default ({order}) => (
  <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
    <p
      style={{
        color:
          order.business != undefined || order.kioskId != undefined
            ? "#143C8A"
            : undefined,
      }}
    >
      {order.assignedWorker != undefined
        ? "(" + order.assignedWorker.name.substring(0, 1) + ") "
        : ""}
      #{order._id.toString().substring(18).toUpperCase()}
    </p>
    <BusinessBadge
      business={order.business}
      showName={false}
    />
  </div>
);
